<template>
  <div
    id="app"
    :class="{
      'custom-header-footer': $config.customHeaderAndFooter
    }"
  >
    <ogs-header
      v-if="$config.customHeaderAndFooter"
    />
    <LocaleChanger />
    <router-view id="page" />
    <ConfirmationModal />
    <ogs-footer
      v-if="$config.customHeaderAndFooter"
    />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';

import ConfirmationModal from '@/components/ConfirmationModal.vue';
import LocaleChanger from '@/components/LocaleChanger.vue';

export default {
  components: {
    ConfirmationModal,
    LocaleChanger,
  },

  computed: {
    ...mapState('usergroups', [
      'usergroupsTypes'
    ])
  },

  async created() {
    await this.GET_USERGROUPS_TYPES();
    for (const usergroupsType of this.usergroupsTypes) {
      this.GET_USERGROUPS_LIST([usergroupsType.codename]);
    }
  },

  mounted() {
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', (e) => {
      this.CLOSE_MODAL(e.componentId.split('-')[0]);
    });
  },

  methods: {
    ...mapMutations('modal', [
      'CLOSE_MODAL'
    ]),
    ...mapActions('usergroups', [
      'GET_USERGROUPS_TYPES',
      'GET_USERGROUPS_LIST'
    ])
  }
};
</script>
